module.exports = __webpack_public_path__ + "img/base_activites_rails.a9becc35.svg";